module.exports = __webpack_public_path__ + "static/img/重复网格 1.6acf318.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/images/重复网格 1.png
// module id = AfNU
// module chunks = 0